export default "__VITE_ASSET__89abac49__"